"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";

// GTM and Ortto, kept off /admin.
//
// They used to load on every route from the root layout, so the team's own
// admin sessions landed in GA4 as "organic" and "social" traffic: /admin/blogs
// and /admin/login were among the top organic landing pages for the year, and
// Ortto opened a chat widget inside the CMS. A first page load under /admin
// now never starts either tag.
const MarketingScripts = () => {
  const pathname = usePathname();
  if (pathname?.startsWith("/admin")) return null;

  return (
    <>
        {/* Google Tag Manager.

            `lazyOnload` rather than `afterInteractive`: GTM pulls itself plus
            gtag — 810 KB of script — and it used to start while the browser was
            still fetching the largest contentful paint image, taking both the
            bandwidth and the main thread it needed. Waiting for the load event
            costs the page_view about a second and costs the measurement nothing;
            the same applies to the Ortto tag below, whose widget drags in a
            jQuery 1.12 and a 57 KB avatar. */}
        <Script id="google-gtm" strategy="lazyOnload">
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-K3WDVG34');
          `}
        </Script>

        {/* Ortto scinternationalhubs capture code */}
        <Script id="ortto-capture" strategy="lazyOnload">
          {`
            window.ap3c = window.ap3c || {};
            var ap3c = window.ap3c;
            ap3c.cmd = ap3c.cmd || [];
            ap3c.cmd.push(function() {
              ap3c.init('aZxVuhpK6yNAGq2vc2NpbnRlcm5hdGlvbmFsaHVicw', 'https://capture-api-us.ortto.app/');
              ap3c.track({v: 0});
            });
            ap3c.activity = function(act) { ap3c.act = (ap3c.act || []); ap3c.act.push(act); };
            var s, t; s = document.createElement('script'); s.type = 'text/javascript'; s.src = "https://cdn3l.ink/app.js";
            t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);
          `}
        </Script>
    </>
  );
};

export default MarketingScripts;
